import { render, staticRenderFns } from "./FeedConnections.vue?vue&type=template&id=1f14ab17"
import script from "./FeedConnections.vue?vue&type=script&lang=js"
export * from "./FeedConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports